import { connect } from 'react-redux';

import AccountManagementView from './AccountManagementView.jsx';
import { updateAccount } from 'src/redux/actions/accounts.ts';

const mapStateToProps = (state, ownProps) => {
  return {
    account: state.accounts.item,
    updating: state.accounts.updating,
    error: state.accounts.error,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateAccount: (account) => {
      return dispatch(updateAccount(account));
    }
  }
}


const AccountManagementPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(AccountManagementView);

export default AccountManagementPage;